<template>
  <v-autocomplete
    :loading="isLoading"
    :items="transportationProfiles"
    :search-input.sync="searchKey"
    :label="label"
    :placeholder="placeholder"
    :disabled="disabled"
    :clearable="clearable"
    hide-no-data
    no-filter
    return-object
    v-model="selectedProfile"
  >
    <template slot="item" slot-scope="{ item }">
      <div style="width: 100%">
        <div>{{ item.licensePlateNumber }}</div>
        <div v-if="item.currentDriverName && showDriver" class="layout row justify-start align-center">
          <div><v-icon small>fal fa-address-card</v-icon></div>
          &nbsp;
          <div>
            <small>{{ item.currentDriverName }}</small>
          </div>
        </div>
        <div v-if="showOwnerAccount" class="layout row justify-start align-center">
          <div><v-icon small>fal fa-users</v-icon></div>
          &nbsp;
          <div>
            <small>
              <span v-show="item.ownerAccountName">{{ item.ownerAccountName }}</span>
              <span v-show="!item.ownerAccountName" style="color: #ccc">Unknown account</span>
            </small>
          </div>
        </div>
        <hr style="width: 100%; border: 0; border-bottom: 1px solid #ccc" />
      </div>
    </template>
    <template slot="selection" slot-scope="{ item }">
      <div>{{ item.licensePlateNumber }}</div>
    </template>
  </v-autocomplete>
</template>

<script>
import src from './src'

export default src
</script>
